import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { PaymentProcessorModel } from 'src/app/admin-panel/models/business/payment-processor.model';
import { UpdatePaymentProcessorModel } from 'src/app/admin-panel/models/business/update-payment-processor.model';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { PaymentProcessorService } from 'src/app/admin-panel/services/business/payment-processor.service';

@Component({
  selector: 'app-add-or-edit-payment-processors',
  templateUrl: './add-or-edit-payment-processors.component.html',
  styleUrls: ['./add-or-edit-payment-processors.component.scss']
})
export class AddOrEditPaymentProcessorsComponent implements OnInit {
  
  //#region Fields
  public paymentProcessorId: string;
  public paymentProcessorModel: PaymentProcessorModel;
  public enableEdit: boolean = false;
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  public countryItem: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public contires: Array<number> = new Array<number>();
  public errorModel: { [k: string]: any } = {};
  public requiredFieldErrorMessage = "BUSINESS.REQUIRED_FIELD";
  //#endregion
  //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public paymentProcessorService: PaymentProcessorService,
    public messageService: MessageService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.paymentProcessorId = this.config.data.id;
    }
   }
  
   ngOnInit(): void {
    this.paymentProcessorModel = new PaymentProcessorModel();
    if (this.paymentProcessorId) {
      this.getPaymentProcessorById(this.paymentProcessorId);
    }
  }
  //#endregion
  
  //#region Public Methods
  getPaymentProcessorById(id: string) {
    this.spinner = true;
    this.paymentProcessorService.getypaymentprocessorbyid(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.enableEdit = true
          this.paymentProcessorModel = response;
          this.paymentProcessorModel.countryIds.map(item =>{
            this.contires.push(item.id);
          })
          this.getallcountrynames();
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });
  }
  getallcountrynames() {
    this.paymentProcessorService.getallcountrynames()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.countryItem = response;
        },
        error: errorResponse => {
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });
  }
  // savePaymentProcessor(model: PaymentProcessorModel) {}
  editPaymentProcessor(paymentProcessorId: string,contiresIds: any[]) {
    this.errorModel = {}
    const model = new UpdatePaymentProcessorModel();
      model.paymentProcessorId = paymentProcessorId;
      model.countryIds = contiresIds;
    if (model && model.countryIds.length == 0) {
      this.errorModel['countryIds'] = this.requiredFieldErrorMessage;
    }
    if (!this.errorModel['countryIds']) {
      this.spinner = true;
      this.paymentProcessorService.updatepaymentprocessor(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error) {
              this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
            }
          }
        });
    }
  }
  cancel() {
    this.ref.close(false)
  }
  //#endregion
  //#Private Methods
  //#endregion

}
